// const data = {
//   id: 1,
//   title: 'Listen and fill the blank with the correct words.',
//   subTitle: 'Nghe và điền từ vào chỗ trống.',
//   audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/a8750e90-08c6-4585-8216-afd5ab63fe77.mp3',
//   question: '',
//   answers: [
//     { id: 1, text: "Hello! My name's Trung. My # is Da Nang.", answers: ['hometown'] },
//     { id: 2, text: 'Last month, I went there by #.', answers: ['plane'] },
//   ],
// };
const data = {
  type: 'FillInTheBlank',
  id: 1,
  title: 'Listen and fill the blank with the correct words.',
  subTitle: 'Nghe và điền từ vào chỗ trống.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/a8750e90-08c6-4585-8216-afd5ab63fe77.mp3',
  imageUrl: '',
  question: "Hello! My name's Trung. My ___ is Da Nang.\r\n Last month, I went there by ___.",
  answers: [
    { id: 1, answer: 'hometown|Hometown' },
    { id: 2, answer: 'plane|Plane' },
  ],

};

export default data;
